<div class="tabbable__body rounded-top-right shadow-z-1 no-margin">
  <h3>Här kan du administrera maxuttag för AG&nbsp;kampanjer</h3>

    @if (estimatesChanged()) {
      <import-warning></import-warning>
    }
    <div class="container">
      <div class="left-item">
        @if(isEditing()) {
          <button class="button primary" (click)="save(form.value)" [disabled]="agWithdrawalLimits.invalid">
            Spara
          </button>

          <button class="link" (click)="cancelEditing()">
            Avbryt redigering
          </button>
        } @else {
          <button class="button primary" (click)="setEditing(true)">
            Redigera maxuttag
          </button>
        }
      </div>

      <div class="right-item">
        @if (productFormatsSig()?.length > 1) {
          <div class="dropdown filter-dropdown margin-left--2x">
            <woo-dropdown
              [items]="productFormatsSig()"
              [ngModel]="selectedProductFormat()"
              (ngModelChange)="selectedProductFormat.set($event)"
              name="selectedProductFormat"
              inputId="select-product-format"
              labelText="Filtrera på Placering"
              [labelTransform]="translateProductFormat"
              notFoundText="Inga Placeringar hittades."
              [clearable]="true"
            ></woo-dropdown>
          </div>
        }

        @if (publishersSig()?.length > 1) {
          <div class="dropdown filter-dropdown margin-left--2x">
            <woo-dropdown
              [items]="publishersSig()"
              [ngModel]="selectedPublisher()"
              (ngModelChange)="selectedPublisher.set($event)"
              name="selectedPublisher"
              inputId="select-publisher"
              labelText="Filtrera på Publicist"
              notFoundText="Inga publicister hittades."
              [clearable]="true"
            ></woo-dropdown>
          </div>
        }
      </div>
    </div>
    <div class="sticky-header">
      <h3>Maxuttag för AG kampanjer</h3>
    </div>

    <form #agWithdrawalLimits="ngForm" ngForm>
      <app-woo-table [data]="displayRows()" [loaderTpl]="loader">
        <woo-table-column header="Publicist" name="publicist"></woo-table-column>
        <woo-table-column header="Placering" name="placering"></woo-table-column>

        <woo-table-column header="Preroll" name="preroll">
          <ng-template let-cell>
            @if (isEditing()) {
              <div class="input__container in">
                <input
                  type="text"
                  [(ngModel)]="$any(cell.row)[cell.columnKey]"
                  [name]="cell.row.id + '|preroll'"
                  [disabled]="!cell.row.enabled"
                  wooPercentFormatter
                  [wooMinValidator]="0"
                  [wooMaxValidator]="1"
                  min="0" max="1" />
              </div>
            } @else {
              {{ cell.value | percent }}
            }
          </ng-template>
        </woo-table-column>

        <woo-table-column header="Midroll" name="midroll">
          <ng-template let-cell>
            @if (isEditing()) {
              <div class="input__container in">
                <input
                  type="text"
                  [(ngModel)]="$any(cell.row)[cell.columnKey]"
                  [name]="cell.row.id + '|midroll'"
                  [disabled]="!cell.row.enabled || !cell.row.midroll"
                  wooPercentFormatter
                  [wooMinValidator]="0"
                  [wooMaxValidator]="1"
                  min="0" max="1" />
              </div>
            } @else {
              {{ cell.row.midroll ? (cell.value | percent) : '-' }} 
            }
          </ng-template>
        </woo-table-column>

        <woo-table-column header="Postroll" name="postroll">
          <ng-template let-cell>
            @if (isEditing()) {
              <div class="input__container in">
                <input
                  type="text"
                  [(ngModel)]="$any(cell.row)[cell.columnKey]"
                  [name]="cell.row.id + '|postroll'"
                  [disabled]="!cell.row.enabled || !cell.row.postroll"
                  wooPercentFormatter
                  [wooMinValidator]="0"
                  [wooMaxValidator]="1"
                  min="0" max="1" />
              </div>
            } @else {
              {{ cell.row.postroll ? (cell.value | percent) : '-' }}
            }
          </ng-template>
        </woo-table-column>
      </app-woo-table>
    </form>

    @if (isEditing()) {
      <div class="margin-top--2x">
        <button class="button primary" (click)="save(form.value)" [disabled]="agWithdrawalLimits.invalid">Spara</button>
        <button class="link" (click)="cancelEditing()">Avbryt redigering</button>
      </div>
    }
  <ng-template #loader let-data>
    <div class="text-center w-100">
      @if(loading()) {
        <dot-loader [large]="true"></dot-loader>
      } @else {
        <span>Ingen data tillgänglig</span>
      }
    </div>
  </ng-template>
</div>

